import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import {Route, Switch} from "react-router-dom";
import {Provider} from "react-redux";
import store, {history} from './store';
import {getBasePath} from "./utils";
import {setupKeybindings} from "./utils/keyboard-shortcuts";
import { ConnectedRouter } from 'connected-react-router'
import {Page} from "./store/coreSlice";
// Stores refs to the map and maps objects
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';

const theme = createMuiTheme({
	palette: {
		primary: teal
	},
});

ReactDOM.render((
	<Provider store={store}>
		<ThemeProvider theme={theme}>
		<ConnectedRouter basename={getBasePath()} history={history}>
			<Switch>
				<Route path='/f/:filterId'>
					<App defaultPage={Page.LIVE} />
				</Route>
				<Route path='/nests'>
					<App defaultPage={Page.NESTS} />
				</Route>
				<Route path='/s2'>
					<App defaultPage={Page.S2} />
				</Route>
				<Route path='/'>
					<App defaultPage={Page.LIVE} />
				</Route>
			</Switch>
		</ConnectedRouter>
		</ThemeProvider>
	</Provider>
), document.getElementById('root'));

setupKeybindings();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
